import { IBuyPackage, EBuyPackageStatus } from '../types';

export const defaultState: IBuyPackage = {
  isModalShow: false,
  isLoading: false,
  status: EBuyPackageStatus.Confirm,
  message: '',
  data: {
    autoProlong: false,
    confirmationToken: '',
    packageId: '',
    packageStartDate: '',
    packageEndDate: '',
    regions: [],
    category: '',
    price: 0,
    marketingPrice: 0,
    discountPercent: 0,
    announcementPrice: 0,
    durationInDays: 0,
    announcementsCount: 0,
    services: [],
    heldPayment: null,
  },
};
